import { publicOrigin, secureOrigin } from '@maxpreps/network/src/origins';
import { useIsSignedIn } from '@maxpreps/shared/redux/user/userHooks';
import styled from 'styled-components';
import THEME from '../../styles/colors';
import Font from '../../styles/font';
import PlusButton, { StyledPlusButton } from '../../ui/Button/PlusButton';
import StyledAnchor from '../../ui/StyledAnchor/StyledAnchor';
import Text from '../../ui/Text/StyledText';
import SmartAnchor from '../Anchor/SmartAnchor';

const StyledFollowingBox = styled.div`
  padding: 16px 0;

  ${StyledAnchor} {
    display: inline-flex;
    align-items: center;
    justify-content: flex-start;
    padding: 8px 0;
    width: 100%;
    &:hover {
      border-color: ${THEME.brand.maxprepsDark};
      ${StyledPlusButton} {
        border-color: ${THEME.brand.maxprepsDark};
        &:hover {
          background-color: transparent;
        }
      }
      span {
        color: ${THEME.brand.maxprepsDark};
      }
      svg,
      svg * {
        fill: ${THEME.brand.maxprepsDark};
      }
    }
  }
`;

const AddTeamButton = () => {
  const isSignedIn = useIsSignedIn();
  const addTeamUrl = isSignedIn
    ? `${secureOrigin}/utility/member/favorites.aspx?favsource=desktop_memberprofile`
    : `${publicOrigin}/search/default.aspx?type=school`;

  return (
    <SmartAnchor href={addTeamUrl}>
      {/* @ts-ignore */}
      <PlusButton as="div" />
      <Text $color={THEME.brand.maxpreps} className={Font.f14_bold_tall}>
        Add Team
      </Text>
    </SmartAnchor>
  );
};

const FollowingBox = () => (
  <StyledFollowingBox>
    <Text
      as="div"
      $color={THEME.text.tertiary}
      className={Font.f11_bold_tall_upper}
      $paddingBottom="8px"
    >
      FOLLOWING
    </Text>
    <AddTeamButton />
  </StyledFollowingBox>
);

export default FollowingBox;
